const ACTION_TYPES = {
  CLICK_TEST_SESSION: 'CLICK_TEST_SESSION',
};

export default ACTION_TYPES;
